import { take, call, put } from 'redux-saga/effects';
import * as types from '../../../lib/actionTypes.es6';
import {
  addEmailTemplateV2,
  getEmailTemplatesV2,
  updateEmailTemplateV2,
  deleteEmailTemplateV2,
} from '../../../lib/requests.es6';
import * as actions from './actions';
import { unAuthorizedNotification } from '../../../lib/access.es6';
import { GAloggerException } from '../../../lib/monitoring.es6';


// template docs

export function* getEmailTemplatesRequestWatcher() {
  while (true) {
    try {
      const { payload } = yield take(types.GET_EMAIL_TEMPLATES_REQUEST);
      const response = yield call(getEmailTemplatesV2, payload);
      yield put(actions.getEmailTemplatesSuccess(response.data));
    } catch (e) {
      let errorPayload = {
        message: 'An error occurred, this could be due to invalid data',
      };
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      yield put(actions.getEmailTemplatesFailed(errorPayload));
      GAloggerException(e);
    }
  }
}

export function* addEmailTemplateRequestWatcher() {
  while (true) {
    try {
      const { payload } = yield take(types.ADD_EMAIL_TEMPLATE_REQUEST);

      const response = yield call(addEmailTemplateV2, payload);
      yield put(actions.addEmailTemplateSuccess(response.data));
      yield put(actions.getEmailTemplateRequest());
    } catch (e) {
      let errorPayload = {
        message: 'An error occurred, this could be due to invalid data',
      };
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      yield put(actions.addEmailTemplateFailed(errorPayload));
      GAloggerException(e);
    }
  }
}

export function* updateEmailTemplateRequestWatcher() {
  while (true) {
    try {
      const { payload } = yield take(types.UPDATE_EMAIL_TEMPLATE_REQUEST);
      const response = yield call(updateEmailTemplateV2, payload);
      yield put(actions.updateEmailTemplateSuccess(response.data));
      yield put(actions.getEmailTemplateRequest());
    } catch (e) {
      let errorPayload = {
        message: 'An error occurred, this could be due to invalid data',
      };
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      yield put(actions.updateEmailTemplateFailed(errorPayload));
      GAloggerException(e);
    }
  }
}

export function* deleteEmailTemplateRequestWatcher() {
  while (true) {
    try {
      const { payload } = yield take(types.DELETE_EMAIL_TEMPLATE_REQUEST);

      const response = yield call(deleteEmailTemplateV2, payload);
      yield put(actions.deleteEmailTemplateSuccess(response.data));
      // Refresh the templates list after successful delete
      yield put(actions.getEmailTemplateRequest());
      
    } catch (e) {
      let errorPayload = {
        message: 'An error occurred, this could be due to invalid data',
      };
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      yield put(actions.deleteEmailTemplateFailed(errorPayload));
      GAloggerException(e);
    }
  }
}
